import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { proxyStorePlugin } from '../commons/proxyStore'

import auth from './modules/auth'
import pagination from './modules/common/pagination'
import searchBox from './modules/common/searchBox'

import organizationDetails from './modules/organizations/details'

import userList from './modules/users/list'
import userDetails from './modules/users/details'

import groupList from './modules/groups/list'
import groupDetails from './modules/groups/details'

import eventFilterOptions from './modules/events/filterOptions'
import eventList from './modules/events/list'
import eventDetails from './modules/events/details'

import eventTemplateList from './modules/eventTemplates/list'
import eventTemplateDetails from './modules/eventTemplates/details'

import scheduledEventList from './modules/scheduledEvents/list'
import scheduledEventDetails from './modules/scheduledEvents/details'

import legalBaseAliasList from './modules/legalBaseAlias/list'
import legalBaseAliasDetails from './modules/legalBaseAlias/details'

import partnerList from './modules/partners/list'
import partnerDetails from './modules/partners/details'

import errorReportList from './modules/errorReports/list'
import errorReportDetails from './modules/errorReports/details'

Vue.use(Vuex)

const store = new Vuex.Store({

  plugins: [
    proxyStorePlugin,
    createPersistedState({
      paths: ['auth.token']
    })
  ],

  modules: {
    auth: { namespaced: true, ...auth },
    pagination: { namespaced: true, ...pagination },
    searchBox: { namespaced: true, ...searchBox },

    userList: { namespaced: true, ...userList },
    userDetails: { namespaced: true, ...userDetails },

    groupList: { namespaced: true, ...groupList },
    groupDetails: { namespaced: true, ...groupDetails },

    eventFilterOptions: { namespaced: true, ...eventFilterOptions },
    eventList: { namespaced: true, ...eventList },
    eventDetails: { namespaced: true, ...eventDetails },

    eventTemplateList: { namespaced: true, ...eventTemplateList },
    eventTemplateDetails: { namespaced: true, ...eventTemplateDetails },

    scheduledEventList: { namespaced: true, ...scheduledEventList },
    scheduledEventDetails: { namespaced: true, ...scheduledEventDetails },

    organizationDetails: { namespaced: true, ...organizationDetails },

    legalBaseAliasList: { namespaced: true, ...legalBaseAliasList },
    legalBaseAliasDetails: { namespaced: true, ...legalBaseAliasDetails },

    partnerList: { namespaced: true, ...partnerList },
    partnerDetails: { namespaced: true, ...partnerDetails },

    errorReportList: { namespaced: true, ...errorReportList },
    errorReportDetails: { namespaced: true, ...errorReportDetails }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js